import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const numberFormats = {
    "nl": {
        currency: {
            style: 'currency', currency: 'EUR', notation: 'standard'
        },
        decimal: {
            style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 5
        },
        percent: {
            style: 'percent', useGrouping: false
        }
    },
    "fr": {
        currency: {
            style: 'currency', currency: 'EUR', notation: 'standard'
        },
        decimal: {
            style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 5
        },
        percent: {
            style: 'percent', useGrouping: false
        }
    },
    "en": {
        currency: {
            style: 'currency', currency: 'EUR', notation: 'standard'
        },
        decimal: {
            style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 5
        },
        percent: {
            style: 'percent', useGrouping: false
        }
    },
};

const dateTimeFormats = {
    "nl": {
        short: {
            year: "numeric",
            month: "short",
            day: "numeric",
        },
        long: {
            year: "numeric",
            month: "long",
            day: "numeric",
            weekday: "long",
            hour: "numeric",
            minute: "numeric",
        },
    },
    "en": {
        short: {
            year: "numeric",
            month: "short",
            day: "numeric",
        },
        long: {
            year: "numeric",
            month: "long",
            day: "numeric",
            weekday: "long",
            hour: "numeric",
            minute: "numeric",
        },
    },
    "fr": {
        short: {
            year: "numeric",
            month: "short",
            day: "numeric",
        },
        long: {
            year: "numeric",
            month: "long",
            day: "numeric",
            weekday: "long",
            hour: "numeric",
            minute: "numeric",
        },
    },
};

function loadLocaleMessages() {
    const locales = require.context(
        "@/locales",
        true,
        /[A-Za-z0-9-_,\s]+\.json$/i
    );
    const messages = {};
    locales.keys().forEach((key) => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}

// Supported languages for this application
const SUPPORTED_LOCALES = ['nl', 'fr', 'en'];
const DEFAULT_LOCALE = 'en';

/**
 * Validates a locale string and returns a supported locale.
 * Falls back to DEFAULT_LOCALE if the locale is not supported.
 * @param {string} locale - The locale to validate (e.g., 'nl', 'en-US', 'de')
 * @returns {string} A supported locale code
 */
export function getSupportedLocale(locale) {
    if (!locale) return DEFAULT_LOCALE;
    const lang = locale.split('-')[0].toLowerCase();
    return SUPPORTED_LOCALES.includes(lang) ? lang : DEFAULT_LOCALE;
}

export default new VueI18n({
    numberFormats,
    dateTimeFormats,
    locale: getSupportedLocale(navigator.language),
    fallbackLocale: DEFAULT_LOCALE,
    fallbackRoot: true,
    silentTranslationWarn: true,
    messages: loadLocaleMessages(),
});
